import { OrderLineSubType } from "../../../../components-shared/enums/order-line-sub-type.js";
import { OrderLineType } from "../../../../components-shared/enums/order-line-type.js";
import { ProductStatusTextType } from "../../../../components-shared/enums/product-status-text-type.js";

export interface TempOrderLineProductContract {
    tempOrderLineID: number;
    productID: number;
    productNo: string;
    productName: string;
    quantity: number;
    lockQuantity: boolean;
    price: number;
    linePrice: number;
    lineDiscount: number;
    lineDiscountPercent: number;
    imageID: number;
    parentID: number;
    preventBuyWhenOutOfStock: boolean;
    canBuyWhenOutOfStock: boolean;
    quantityInStock: number;
    itemID: number;
    productImageID: number;
    imageWidth: number;
    currencyCode: string;
    exchangeRate: number;
    published: boolean;
    formattedPrice: string;
    formattedOriginalPrice: string;
    formattedLinePrice: string;
    formattedOriginalLinePrice: string;
    formattedDiscount: string;
    factor: number;
    publishedPageID: number;
    isMainProduct: boolean;
    imageFullWidth: number;
    imageFullHeight: number;
    imageDisplayWidth: number;
    imageDisplayHeight: number;
    imageUrl: string;
    productUrl: string;
    cantBeRemoved: boolean;
    stockText: string;
    stockColor: string;
    stockCssClass: string;
    productStatusTextType: ProductStatusTextType;
    hideStockInfo: boolean; // do we need it? Only for child products?
    minQuantity: number;
    allowedQuantities: number[];
    unit: string;
    isFractional: boolean;
    factorPurchaseType: FactorPurchaseType;
    lineType: OrderLineType;
    lineSubType?: OrderLineSubType;
    offerID?: number;
    supplierOrderLines?: string[];
    supplierDeliveryTime?: number;
    customFields: CustomFieldValueCartItem[];
    //sellingRules: SellingRules //Alex D. recommended to group selling rules
}

export interface CustomFieldValueCartItem {
    fieldID: number;
    fieldLabel: string;
    fieldValue: string;
    sortOrder: number;
}

export interface TempOrderLineProductContractUiHelper extends TempOrderLineProductContract{
    grouping?:{
        id: number;
        position: GroupPosition;
        isChild: boolean;
    }
}

//public class SellingRules {
   // allowedQuantities { get; set; }
   // minQuantity { get; set; }
//}

export enum GroupPosition {
    First = 'first',
    Middle = 'middle',
    Last = 'last',
}

export enum FactorPurchaseType{
    None = 0, // Non factor product
    Both = 1, // Can be bought a single product and a pack of products
    Single = 2, // Only single product can be bought
    Package = 3 // Only package of products can be bought
}